import BResourcePage from "../../../components/resources/BResourcePage";

function MaklersPage() {
  return (
    <BResourcePage
      title={"Makler"}
      url={"/Brokers"}
      fieldsVisibleAtBeginning={[
        "id",
        "email",
        "firstName",
        "lastName",
        "points",
        "province",
      ]}
    />
  );
}

export default MaklersPage;
